import { AuditSchedule } from '@mi-front/core';
import { Chip, MrtTable } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { LDate } from '../../../../../../components/date/LDate';
import { LTime } from '../../../../../../components/date/LTime';
import { ListingResultProps } from '../../../../../../core/reports/components/ListingView';
import { ScheduleTolerance } from '../../../../components/schedule/ScheduleTolerance';
import { SchedulesSpotListing } from '../spot/SchedulesSpotListView';

import { FormattedMessage } from 'react-intl';
export function SchedulesListMentionsResult(p: ListingResultProps<SchedulesSpotListing>) {
  const { $t } = useIntl();

  return (
    <MrtTable
      {...p.mrtProps}
      columns={[
        {
          header: $t({
            id: 'audit.props.datetime',
            defaultMessage: 'Fecha y hora programada',
          }),
          accessorKey: 'datetime',
          Cell: ({ row }) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <LDate value={row.original.datetime} day="2-digit" month="2-digit" year="2-digit" />
              <LTime value={row.original.datetime} />
            </div>
          ),
          size: 150,
        },
        {
          header: $t({
            id: 'audit.props.customAudioId',
            defaultMessage: 'ID media',
          }),
          accessorKey: 'customId',
          size: 150,
        },
        {
          header: $t({
            id: 'audit.props.tolerance',
            defaultMessage: 'Tolerancia (mins)',
          }),
          Cell: ({ row }) => <ScheduleTolerance config={row.original.toleranceConfig} />,
          size: 150,
        },
        {
          header: $t({
            id: 'audit.schedulesListScreen.props.status',
            defaultMessage: 'Estado',
          }),
          Cell: ({ row }) => {
            return <ScheduleStatus schedule={row.original} />;
          },
        },
      ]}
    />
  );
}

export function ScheduleStatus(p: { schedule: AuditSchedule; size?: 'sm' }) {
  const { schedule } = p;

  if (!schedule.mentionMatch) {
    return (
      <Chip type="light">
        <FormattedMessage id="audit.schedulesListScreen.noMatch" defaultMessage="Sin match" />
      </Chip>
    );
  }

  const match = schedule.mentionMatch;
  const diff = (new Date(match.datetime).valueOf() - new Date(schedule.datetime).valueOf()) / 60000;

  return (
    <Chip size={p.size} type="success">
      <LTime value={match.datetime} second="2-digit" />{' '}
      <FormattedMessage
        id="audit.schedulesList.mentions.diff"
        defaultMessage=" - Diff: {diff} min"
        values={{ diff: diff.toFixed(1) }}
      />
    </Chip>
  );
}
